/* URSA size guide + size finder (URSA custom). Rebuilt 6 Oct 2026, pouches added 8 Oct 2026.
   "Size guide" and "Find my size" sit on their own row under Colour and Size, from the left edge. Size guide opens this product's own chart inline.
   Only on the products listed in CFG. Ranges come from each product page:
   - Waist straps (single, double), Live straps (single, double), Sideways: FAQs strap guide (Sam confirmed Live + Sideways match).
   - Back Strap: description ranges (Sam confirmed; the chart section lower on that page is wrong).
   - X Strap: description + chart. Shorties, Vesties, Undies: dress size charts on each page.
   - Pouches (8 Oct, Catarina): Belt Pouch from its description table; Popper Pouch assumed to share the Belt Pouch sizes (CHECK);
     Performance Pouch from the size photos in its gallery; Live Pouch from its description. Pouch "Find my size" = pick your transmitter.
   8 Oct 2026 (Catarina): cm is the default unit; Enter in the box no longer submits the product form (no flicker/refresh);
   out-of-range sizes always show the measuring note plus "outside our standard size range".
   12 Oct 2026 (Sam's notes for Kat): pouch "Find my size" is now brand then model buttons (no dropdown). The old dropdown sat inside the
   variant picker, so the Product tools "Select Mini" button changed it by mistake and picked the wrong size. Zaxcom ZMT4 added under Mini (CHECK).
   Backups: assets/ursa-size-guide.js.before-feedback-2026-10-12.txt (git tag pre-cleanup-2026-10-19), assets/ursa-size-guide.js.before-carnival-2026-10-08.txt (git tag pre-cleanup-2026-10-19), assets/ursa-size-finder.js.before-rebuild-2026-10-06.txt (git tag pre-cleanup-2026-10-19) */
(function () {
  'use strict';
  var WAIST = { type: 'm', what: 'Waist', lab: 'Your waist measurement', note: 'Measure around your waist where the strap will sit.',
    sizes: [{ k: 'S', a: 24, b: 32 }, { k: 'M', a: 29, b: 42 }, { k: 'L', a: 37, b: 50 }, { k: 'XL', a: 45, b: 62 }] };
  var CHEST_NOTE = 'Measure around your chest at the widest point, around the armpits.';
  var BACK = { type: 'm', what: 'Chest', lab: 'Your chest measurement', note: CHEST_NOTE,
    sizes: [{ k: 'S', a: 32, b: 36 }, { k: 'M', a: 36, b: 40 }, { k: 'L', a: 41, b: 45 }] };
  var XSTRAP = { type: 'm', what: 'Chest', lab: 'Your chest measurement', note: CHEST_NOTE,
    sizes: [{ k: 'S', a: 34, b: 37 }, { k: 'M', a: 37, b: 39 }, { k: 'L', a: 39, b: 42 }, { k: 'XL', a: 42, b: 45 }] };
  var DRESS = { type: 'd', sizes: [
    { k: 'S', UK: [6, 8], EU: [34, 36], US: [2, 4] }, { k: 'M', UK: [10, 12], EU: [38, 40], US: [6, 8] },
    { k: 'L', UK: [14, 16], EU: [42, 44], US: [10, 12] }, { k: 'XL', UK: [18, 20], EU: [46, 48], US: [14, 16] }] };
  var UNDIES = { type: 'd', sizes: [
    { k: 'S', UK: [4, 8], EU: [32, 36], US: [1, 4] }, { k: 'M', UK: [10, 14], EU: [38, 42], US: [6, 10] },
    { k: 'L', UK: [16, 20], EU: [44, 48], US: [12, 16] }] };
  var POUCH4 = [
    { v: 'Mini', n: 'Mini', d: '86 × 52 mm', f: 'Lectrosonics SSM, Zaxcom ZMT3, Zaxcom ZMT4, Q5X PlayerMic S (tight fit)' },
    { v: 'Small', n: 'Small', d: '86 × 55 mm', f: 'Sound Devices A20 Mini, Wisycom MTP61, Sennheiser SK6212, Lectrosonics SMV' },
    { v: 'Medium', n: 'Medium', d: '86 × 75 mm', f: 'Lectrosonics SMQV, Shure ADX1M, Tascam DR-10L, Wisycom MTP40, Wisycom MTP41' },
    { v: 'Large', n: 'Large', d: '99 × 78 mm', f: 'Sound Devices A10, Sound Devices A20, Wisycom MTP60, Wisycom MPR50, Shure PSM1000, Sony UWP' }];
  var BELT = { type: 'p', sizes: POUCH4.concat([{ v: 'XL Q5X', n: 'XL Q5X', d: 'Sized for Q5X', f: 'Q5X PlayerMic' }]) };
  var POPPER = { type: 'p', sizes: POUCH4 };
  var PERF = { type: 'p', note: 'Usable space is the inside depth from the opening to the bottom of the pouch.', sizes: [
    { v: 'S - SK6212', n: 'Small', d: '6.5 × 10.5 cm (usable 8.2 cm)', f: 'Sennheiser SK6212, Sound Devices A20 Mini, Lectrosonics SMV, Wisycom MTP61' },
    { v: 'M - ADX1M', n: 'Medium', d: '8 × 9 cm (usable 6.8 cm)', f: 'Shure ADX1M, Wisycom MTP41' },
    { v: 'L - G4', n: 'Large', d: '9 × 13 cm (usable 10.6 cm)', f: 'Sennheiser G4, Shure ADX1' }] };
  var LIVEP = { type: 'p', sizes: [
    { v: 'Medium', n: 'Medium', d: '9 × 10 cm', f: 'Sennheiser SPECTERA, Sennheiser G4, Sennheiser XSW IEM, Line 6 Relay G30, Line 6 Relay G50, Shure GLX, Shure DLX, Shure ULX' },
    { v: 'Large', n: 'Large', d: '9 × 14.5 cm', f: 'Shure BLX, Shure P3RA, Gear4Music receivers, LD Systems U508' }] };
  var CFG = {
    'waist-strap': WAIST, 'ursa-double-pouch-waist-straps': WAIST, 'ursa-waist-strap-sideways-pouch': WAIST,
    'ursa-live-straps': WAIST, 'live-strap-double-pouch': WAIST,
    'backstraps': BACK, 'ursa-x-strap': XSTRAP,
    'shorties': DRESS, 'ursa-vesties': DRESS, 'ursa-undies': UNDIES,
    'belt-pouch': BELT, 'ursa-popper-pouches': POPPER, 'performance-pouch': PERF, 'ursa-live-pouches': LIVEP
  };
  var NAMES = { S: 'Small', M: 'Medium', L: 'Large', XL: 'X-Large' };
  var ALIAS = { S: ['s', 'small'], M: ['m', 'medium'], L: ['l', 'large'], XL: ['xl', 'x-large', 'extra large', 'x large'] };

  var mt = location.pathname.match(/\/products\/([^\/?#]+)/);
  var cfg = mt && CFG[decodeURIComponent(mt[1]).toLowerCase()];
  if (!cfg) return;

  var st = { open: null, unit: 'cm', val: '', region: 'UK', dress: null, focus: false, tx: '', brand: '' };
  var BRANDS = ['Sound Devices', 'Lectrosonics', 'Line 6', 'LD Systems', 'Gear4Music', 'Sennheiser', 'Wisycom', 'Zaxcom', 'Tascam', 'Shure', 'Sony', 'Q5X'];
  function brandOf(t) { for (var i = 0; i < BRANDS.length; i++) if (t.indexOf(BRANDS[i] + ' ') === 0 || t === BRANDS[i]) return BRANDS[i]; return t.split(' ')[0]; }
  function modelOf(t) { var b = brandOf(t); return t.indexOf(b + ' ') === 0 ? t.slice(b.length + 1) : t; }
  var RULER = '<svg viewBox="0 0 20 20" aria-hidden="true"><rect x="1.5" y="6" width="17" height="8" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M5 6v3M8 6v2M11 6v3M14 6v2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

  function isSizeLegend(l) { var t = (l.textContent || '').trim(); return /^size\b/i.test(t) && !/pouch/i.test(t); }
  function inputs() {
    return [].slice.call(document.querySelectorAll('variant-picker input[type="radio"]'))
      .filter(function (i) { return /^size\b/i.test(i.name) && !/pouch/i.test(i.name); });
  }
  function inputFor(k) {
    if (cfg.type === 'p') return inputs().filter(function (i) { return i.value.trim() === k; })[0] || null;
    var al = ALIAS[k];
    return inputs().filter(function (i) { return al.indexOf(i.value.trim().toLowerCase()) > -1; })[0] || null;
  }
  function keyOf(z) { return cfg.type === 'p' ? z.v : z.k; }
  function avail() {
    if (!inputs().length) return cfg.sizes;
    var s = cfg.sizes.filter(function (z) { return !!inputFor(keyOf(z)); });
    return s.length ? s : cfg.sizes;
  }
  function cm(x) { return Math.round(x * 2.54); }
  function mk(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function rng(r) { return r[0] + '–' + r[1]; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function guideHTML() {
    var s = avail(), h;
    if (cfg.type === 'm') {
      h = '<table class="usf-tbl"><thead><tr><th scope="col">Size</th><th scope="col">' + cfg.what + ' (cm)</th><th scope="col">' + cfg.what + ' (in)</th></tr></thead><tbody>';
      s.forEach(function (z) { h += '<tr><th scope="row">' + NAMES[z.k] + '</th><td>' + cm(z.a) + ' to ' + cm(z.b) + '</td><td>' + z.a + '" to ' + z.b + '"</td></tr>'; });
      h += '</tbody></table><p class="usf-note">' + cfg.note + '</p>';
    } else if (cfg.type === 'p') {
      h = '<table class="usf-tbl"><thead><tr><th scope="col">Size</th><th scope="col">Pouch size</th><th scope="col">Fits</th></tr></thead><tbody>';
      s.forEach(function (z) { h += '<tr><th scope="row">' + esc(z.n) + '</th><td>' + esc(z.d) + '</td><td class="usf-fits">' + esc(z.f) + '</td></tr>'; });
      h += '</tbody></table><p class="usf-note">' + (cfg.note ? cfg.note + ' ' : '') + 'Not sure? <a href="/pages/contact">Ask us</a> and we will match a pouch to your transmitter.</p>';
    } else {
      h = '<table class="usf-tbl"><thead><tr><th scope="col">Size</th><th scope="col">UK</th><th scope="col">EU</th><th scope="col">US</th></tr></thead><tbody>';
      s.forEach(function (z) { h += '<tr><th scope="row">' + NAMES[z.k] + '</th><td>' + rng(z.UK) + '</td><td>' + rng(z.EU) + '</td><td>' + rng(z.US) + '</td></tr>'; });
      h += '</tbody></table><p class="usf-note">Dress sizes. If you\'re between sizes, we recommend the larger size for a more comfortable fit.</p>';
    }
    return h;
  }

  function dressVals(region) {
    var lo = Infinity, hi = -Infinity, v = [];
    avail().forEach(function (z) { lo = Math.min(lo, z[region][0]); hi = Math.max(hi, z[region][1]); });
    if (lo % 2) lo++;
    for (var i = lo; i <= hi; i += 2) v.push(i);
    return v;
  }
  function txList() {
    var all = [];
    avail().forEach(function (z) { z.f.replace(/\s*\(tight fit\)/i, '').split(/\s*,\s*/).forEach(function (t) { if (t && all.indexOf(t) < 0) all.push(t); }); });
    return all.sort(function (a, b) { return a.localeCompare(b); });
  }

  function build() {
    var lg = [].slice.call(document.querySelectorAll('variant-picker legend')).filter(isSizeLegend)[0];
    if (!lg) return;
    var fs = lg.closest('fieldset');
    if (!fs) return;
    /* 17 Oct 2026: if the theme printed an empty .usf-slot after this fieldset (snippets/variant-main-picker.liquid), build inside it. The slot is
       skipped by the theme's variant-change re-render, so the row is no longer removed and re-added on every size/colour tap (flicker + page jump). */
    var slot = fs.nextElementSibling && fs.nextElementSibling.classList.contains('usf-slot') ? fs.nextElementSibling : null;
    var nx = slot ? slot.firstElementChild : fs.nextElementSibling;
    if (nx && nx.classList.contains('usf-wrap')) return;
    document.querySelectorAll('.usf-wrap').forEach(function (x) { x.remove(); });

    var tools = mk('div', 'usf-tools');
    var gBtn = mk('button', 'usf-guide', RULER + '<span>Size guide</span>');
    var fBtn = mk('button', 'usf-open', 'Find my size');
    gBtn.type = fBtn.type = 'button';
    tools.appendChild(gBtn); tools.appendChild(fBtn);

    var wrap = mk('div', 'usf-wrap');
    wrap.appendChild(tools);
    var pg = mk('div', 'usf-panel usf-panel--guide', guideHTML());
    var pf = mk('div', 'usf-panel usf-panel--find');
    wrap.appendChild(pg); wrap.appendChild(pf);
    if (slot) slot.appendChild(wrap); else fs.insertAdjacentElement('afterend', wrap);

    var input = null, sel = null, out, lowT;
    if (cfg.type === 'm') {
      pf.innerHTML = '<label class="usf-lab" for="usf-val">' + cfg.lab + '</label>' +
        '<div class="usf-row"><input id="usf-val" class="usf-in" type="number" inputmode="decimal" enterkeyhint="done" min="10" max="200" step="0.5">' +
        '<div class="usf-seg" role="group" aria-label="Unit"><button type="button" data-u="cm">cm</button><button type="button" data-u="in">in</button></div></div>' +
        '<p class="usf-note">' + cfg.note + '</p><div class="usf-out" aria-live="polite"></div>';
      input = pf.querySelector('.usf-in');
      input.value = st.val;
      pf.querySelectorAll('[data-u]').forEach(function (b) {
        b.addEventListener('click', function () {
          var nu = b.getAttribute('data-u');
          if (nu !== st.unit && st.val) {
            var n = parseFloat(st.val);
            if (n) { st.val = String(nu === 'cm' ? Math.round(n * 2.54) : Math.round(n / 2.54 * 2) / 2); input.value = st.val; }
          }
          st.unit = nu; seg(); calc();
        });
      });
      input.addEventListener('input', function () { st.val = input.value; st.focus = true; calc(); });
      input.addEventListener('blur', function () { st.focus = false; });
      // Enter must not submit the product form (it made the page flicker and reload)
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); e.stopPropagation(); st.val = input.value; calc(true); input.blur(); }
      });
    } else if (cfg.type === 'p') {
      pf.innerHTML = '<p class="usf-lab" id="usf-bl">Your transmitter brand</p><div class="usf-chips" role="group" aria-labelledby="usf-bl" data-usf-brands></div>' +
        '<div data-usf-models></div><div class="usf-out" aria-live="polite"></div>';
      var bWrap = pf.querySelector('[data-usf-brands]'), mWrap = pf.querySelector('[data-usf-models]');
      var txs = txList(), brands = [];
      txs.forEach(function (t) { var b = brandOf(t); if (brands.indexOf(b) < 0) brands.push(b); });
      brands.sort(function (a, b) { return a.localeCompare(b); });
      if (st.tx && st.tx !== '__other') st.brand = brandOf(st.tx);
      var chip = function (label, attr, val, on) { return '<button type="button" class="usf-chip" ' + attr + '="' + esc(val) + '" aria-pressed="' + on + '">' + esc(label) + '</button>'; };
      var drawBrands = function () {
        bWrap.innerHTML = brands.map(function (b) { return chip(b, 'data-b', b, st.brand === b); }).join('') + chip('Not listed', 'data-b', '__other', st.tx === '__other');
      };
      var drawModels = function () {
        if (!st.brand || st.tx === '__other') { mWrap.innerHTML = ''; return; }
        var ms = txs.filter(function (t) { return brandOf(t) === st.brand; });
        mWrap.innerHTML = '<p class="usf-lab" id="usf-ml" style="margin-top:12px">' + esc(st.brand) + ' model</p><div class="usf-chips" role="group" aria-labelledby="usf-ml">' +
          ms.map(function (t) { return chip(modelOf(t), 'data-t', t, st.tx === t); }).join('') + '</div>';
      };
      drawBrands(); drawModels();
      pf.addEventListener('click', function (e) {
        var b = e.target.closest('[data-b]'), t = e.target.closest('[data-t]');
        if (b) {
          var v = b.getAttribute('data-b');
          if (v === '__other') { st.brand = ''; st.tx = '__other'; }
          else { st.brand = v; var only = txs.filter(function (x) { return brandOf(x) === v; }); st.tx = only.length === 1 ? only[0] : ''; }
          drawBrands(); drawModels(); calc(); return;
        }
        if (t) { st.tx = t.getAttribute('data-t'); drawModels(); calc(); }
      });
    } else {
      pf.innerHTML = '<p class="usf-lab">Your usual dress size</p>' +
        '<div class="usf-seg" role="group" aria-label="Size system"><button type="button" data-r="UK">UK</button><button type="button" data-r="EU">EU</button><button type="button" data-r="US">US</button></div>' +
        '<div class="usf-dress" role="group" aria-label="Dress size"></div><div class="usf-out" aria-live="polite"></div>';
      pf.querySelectorAll('[data-r]').forEach(function (b) {
        b.addEventListener('click', function () { st.region = b.getAttribute('data-r'); st.dress = null; seg(); dressRow(); calc(); });
      });
    }
    out = pf.querySelector('.usf-out');

    function seg() {
      pf.querySelectorAll('[data-u]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-u') === st.unit)); });
      pf.querySelectorAll('[data-r]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-r') === st.region)); });
      if (input) input.placeholder = st.unit === 'in' ? (cfg.what === 'Waist' ? 'e.g. 34' : 'e.g. 38') : (cfg.what === 'Waist' ? 'e.g. 86' : 'e.g. 96');
    }
    function dressRow() {
      var row = pf.querySelector('.usf-dress');
      if (!row) return;
      row.innerHTML = '';
      dressVals(st.region).forEach(function (v) {
        var b = mk('button', 'usf-d', String(v));
        b.type = 'button';
        b.setAttribute('aria-pressed', String(st.dress === v));
        b.addEventListener('click', function () { st.dress = v; dressRow(); calc(); });
        row.appendChild(b);
      });
    }
    function pick(k) {
      var inp = inputFor(k);
      if (inp && !inp.disabled && !inp.checked) inp.click();
      mark();
    }
    function mark() {
      out.querySelectorAll('.usf-pick').forEach(function (b) {
        var inp = inputFor(b.getAttribute('data-k'));
        b.classList.toggle('is-on', !!(inp && inp.checked));
      });
    }
    function outside() {
      var p = mk('p', 'usf-msg');
      p.innerHTML = (cfg.type === 'm' ? '<span class="usf-hint">' + cfg.note + '</span>' : '') +
        'That is outside our standard size range. <a href="/pages/contact">Get in touch</a> and we can help.';
      out.innerHTML = ''; out.appendChild(p);
    }
    function calc(now) {
      clearTimeout(lowT);
      out.innerHTML = '';
      var s = avail(), matches = [], gap = false, label;
      if (cfg.type === 'm') {
        var v = parseFloat(st.val);
        if (!v || v <= 0) return;
        var inch = st.unit === 'cm' ? v / 2.54 : v;
        if (inch < 15) { if (now) outside(); else lowT = setTimeout(outside, 1200); return; } /* still typing */
        matches = s.filter(function (z) { return inch >= z.a && inch <= z.b; });
        if (!matches.length && inch > s[0].a && inch < s[s.length - 1].b) {
          matches = [s.filter(function (z) { return z.b < inch; }).pop(), s.filter(function (z) { return z.a > inch; })[0]].filter(Boolean);
          gap = true;
        }
        label = function (z) { return st.unit === 'cm' ? cm(z.a) + ' to ' + cm(z.b) + ' cm' : z.a + '" to ' + z.b + '"'; };
      } else if (cfg.type === 'p') {
        if (!st.tx) return;
        if (st.tx === '__other') {
          var po = mk('p', 'usf-msg');
          po.innerHTML = 'Tell us your transmitter and we will match the right pouch. <a href="/pages/contact">Get in touch</a>.';
          out.appendChild(po); return;
        }
        matches = s.filter(function (z) { return z.f.split(/\s*,\s*/).map(function (t) { return t.replace(/\s*\(tight fit\)/i, ''); }).indexOf(st.tx) > -1; });
        label = function (z) { return z.d; };
      } else {
        if (st.dress == null) return;
        matches = s.filter(function (z) { return st.dress >= z[st.region][0] && st.dress <= z[st.region][1]; });
        label = function (z) { return st.region + ' ' + rng(z[st.region]); };
      }
      if (!matches.length) { outside(); return; }
      var p = mk('p', 'usf-msg');
      p.textContent = matches.length > 1 ? (gap ? 'You are just between sizes. Either should work:' : (cfg.type === 'p' ? 'Fits either of these:' : 'You are between sizes. Either of these fits:')) : 'Your size:';
      out.appendChild(p);
      var row = mk('div', 'usf-picks');
      matches.forEach(function (z) {
        var k = keyOf(z);
        var b = mk('button', 'usf-pick', 'Select ' + (cfg.type === 'p' ? z.n : NAMES[z.k]) + ' (' + label(z) + ')');
        b.type = 'button';
        b.setAttribute('data-k', k);
        b.addEventListener('click', function () { pick(k); });
        row.appendChild(b);
      });
      out.appendChild(row);
      if (matches.length === 1) pick(keyOf(matches[0])); else mark();
    }
    function show() {
      pg.hidden = st.open !== 'guide';
      pf.hidden = st.open !== 'find';
      gBtn.setAttribute('aria-expanded', String(st.open === 'guide'));
      fBtn.setAttribute('aria-expanded', String(st.open === 'find'));
    }
    gBtn.addEventListener('click', function () { st.open = st.open === 'guide' ? null : 'guide'; show(); });
    fBtn.addEventListener('click', function () {
      st.open = st.open === 'find' ? null : 'find'; show();
      if (st.open === 'find' && input) input.focus();
    });

    seg(); dressRow(); show(); calc();
    if (st.focus && input && st.open === 'find') { input.focus(); try { var l = input.value.length; input.setSelectionRange(l, l); } catch (e) {} }
  }

  function init() {
    build();
    var tm;
    if (window.MutationObserver) {
      new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(build, 60); })
        .observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
